export const QUESTION_TYPES = [
  'short_text',
  'long_text',
  'number',
  'multiple_choice',
  'single_choice',
  'yes_no',
  'email',
  'website',
  'number_range',
  'location',
  'date',
  'prototype_test',
  'card_sort',
  'tree_test',
  'matrix'
];

export const isDisplayable = (fieldType: ScreenerFieldType) => QUESTION_TYPES.includes(fieldType);

export const formatMilliseconds = (milliseconds: number) => {
  if (milliseconds < 0) {
    return 'Invalid duration';
  }

  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes === 0) {
    return `${seconds} sec`;
  }

  return `${minutes} min ${seconds} sec`;
};

export const formatMillisecondsAsMMSS = (milliseconds: number) => {
  if (milliseconds < 0) {
    return '00:00';
  }

  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
